import api from '@/api/api.js'

export default {
    getListeDepots(data) {
        const promise = api.comptabilite().post('/depots/liste', data)
        return promise.then((response) => response.data)
    },

    saveDepot(data) {
        const promise = api.comptabilite().post('/depots', data)
        return promise.then((response) => response.data)
    },

    getDepotPatient(patient_id) {
        const promise = api.comptabilite().get('/depots/patient/'+patient_id)
        return promise.then((response) => response.data)
    },

    payBackDepotPatient(data) {
        const promise = api.comptabilite().post('/depots/reverser-depot', data)
        return promise.then((response) => response.data)
    },
}